import abLS from '@/business/abLocalStorage'
import api from '@/apiFetch/house'
import loginApi from '@/apiFetch/login'

var actions = {
  init({
    state,
    commit,
    getters,
    dispatch
  }) {
    // 主要考虑刷新后，state都是空的，从缓存中取
    if (!state.hotelId) {
      commit('setHotelId', abLS.getHotelId())
    }
    // if (!state.hotelInfo.hasOwnProperty('hotelId')) {
    //   commit('setHotelInfo', abLS.getHotelInfo())
    // }
    // if (!state.hotelList.length) {
    //   commit('setHotelList', abLS.getHotelList())
    // }
    dispatch('getHotelListAction')
  },
  /**
   * @description 获取门店列表，如果当前门店为空，同时设置当前门店为列表的第一个门店
   * @param {*} {
   *     state,
   *     commit,
   *     getters
   *   } store
   * @param {String} source 标示不一样的来源，来自登录的话会做不一样的操作
   */
  getHotelListAction({
    state,
    commit,
    getters,
    dispatch,
    rootState
  }) {
    if (!rootState.accessToken) {
      return
    }
    api.getHotelList()
      .then((data) => {
        // 允许创建的最大门店数
        commit('setAllowHotelCount', data.allowHotelCount)
        // 没有门店需要清除缓存，因为最后一个门店也是可以删除的
        commit('setHotelList', data.hotels)
        if (data.hotels.length === 0) {
          commit('setHotelInfo', {})
          commit('setHotelId', 0)
          return
        }
        if (state.hotelId) {
          // 更新当前门店的信息，现在好像没有什么用（刷新后需要）
          const theHotel = data.hotels.filter((item) => {
            return state.hotelId === item.hotelId
          })[0]
          if (theHotel) {
            commit('setHotelInfo', theHotel)
            dispatch('checkUserIsBindWechart')
          } else {
            dispatch('changeHotel', data.hotels[0].hotelId)
          }
        } else {
          // 如果当前没有门店，就默认切换到第一个门店（删除当前门店或者登录时会执行）
          dispatch('changeHotel', data.hotels[0].hotelId)
        }
      }).catch((e) => {
        this.$Message.error(e.errorMsg)
      })
  },
  /**
   * @description 切换门店后，需要重新加载页面
   * @param {Object} {
   *     state,
   *     commit,
   *     getters
   *   }
   * @param {String} hotelId 门店ID
   */
  changeHotel({
    state,
    commit,
    getters,
    dispatch,
    rootState
  }, hotelId) {
    api.changeHotel({ hotelId })
      .then((data) => {
        state.hotelList.map(item => {
          if (hotelId === item.hotelId) {
            commit('setHotelInfo', item)
          }
        })
        commit('setHotelId', hotelId)
        // 切换门店后，所有的数据都需要更新，干脆直接刷新
        // 刷新时，如果当前页面在详情页面，会跳回到他的上一个页面，是否详情页面需要在router中配置
        const currentRoute = rootState.currentRoute
        const url = currentRoute.meta.isDetailPage ? currentRoute.matched[currentRoute.matched.length - 2].path : currentRoute.path
        window.location = url
      }).catch((e) => {
        this.$Message.error(e.errorMsg)
      })
  },
  /**
   * @description 查询用户是否绑定公众号， 每次切换门店后都需要查询
   * @param {Object} {
   *     state,
   *     commit,
   *     getters,
   *     dispatch,
   *     rootState }
   */
  checkUserIsBindWechart({
    state,
    commit,
    getters,
    dispatch,
    rootState }) {
    loginApi.checkUserIsBindWechart()
      .then((data) => {
        // binded 0：未绑定，1：绑定'
        commit('setIsBindWechart', data.binded !== 0)
      }).catch((e) => {
        commit('setIsBindWechart', false)
      })
  }
}
export default actions
